import Icon, { ICONS_TYPES } from '@/components/Icon';
import { Tooltip } from '@mui/material';
import { selectTradeValuationDate } from '@store/dashboard/selectors';
import moment from 'moment-timezone';
import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  DATA_DATE_FORMAT,
  DATA_DATE_REGIONS,
  VALUE_DATE_NY_HOUR,
} from './constants';
import {
  DataDateContainer,
  InfoIcon,
  Label,
  TooltipContent,
  TooltipList,
} from './styles';

const DataDateInfo: FC = () => {
  const tradeValuationDate = useSelector(selectTradeValuationDate);

  const regionTimes = useMemo(() => {
    // 17:00 New York on the latest value date is the single instant all values
    // are "as of"; every other region shows that same instant in its own tz.
    const nyClose = tradeValuationDate
      ? moment.tz(
          `${moment(tradeValuationDate).format('YYYY-MM-DD')} ${VALUE_DATE_NY_HOUR}:00`,
          'America/New_York',
        )
      : null;

    return DATA_DATE_REGIONS.map(({ label, timezone: tz }) => ({
      label,
      value: nyClose ? nyClose.tz(tz).format(DATA_DATE_FORMAT) : '—',
    }));
  }, [tradeValuationDate]);

  const dataDateTooltip = (
    <TooltipContent>
      All values as of:
      <TooltipList id="dataDateTooltipList">
        {regionTimes.map(({ label, value }) => (
          <li key={label}>
            * {label}: {value}
          </li>
        ))}
      </TooltipList>
      All values shown are from the Client&apos;s perspective (a negative value
      means the Client owes the Bank)
    </TooltipContent>
  );

  return (
    <DataDateContainer>
      <Label>All values as of</Label>
      <Tooltip title={dataDateTooltip} arrow placement="top">
        <InfoIcon>
          <Icon icon={ICONS_TYPES.InfoCircle} size={16} />
        </InfoIcon>
      </Tooltip>
    </DataDateContainer>
  );
};

export default DataDateInfo;
